<template>
  <div class="examinee-mode-wrap">
    <div class="list" v-if="examineeUserId">
      <list-header ref="headerRef"></list-header>
      <div class="content flex-content-between">
        <answer-area :current-question="currentQuestion" :current-answer="currentAnswer"></answer-area>
        <score-area :examinee-info="examineeInfo" :question-list="questionList" :current-question="currentQuestion"
          :current-answer="currentAnswer" :is-first="isFirst" :is-last="isLast" @showSearchDialog="showSearchDialog"
          @changeQuestion="changeQuestion" @submit="submitScore"></score-area>
      </div>
      <div class="loading-mask" v-if="loading">
        <loading :box-size="16" :round-size="4" :color="'#306FFF'"></loading>
      </div>
      <Modal width="330px" speed="fast" noOutClose maskNoClick noClose noHeader noFooter enter-active-class="fadeIn"
        leave-active-class="fadeOut" @update:show="showDoneModal = false" :show="showDoneModal" class="done-modal">
        <div slot="content">
          <span class="icon-done"></span>
          <p>阅卷完成！</p>
          <button class="btn" @click="onAllDone">知道了</button>
        </div>
      </Modal>
    </div>
    <search-examinee-dialog ref="searchExamineeDialogRef" :judge-id="judgeId" :marking-id="markingId"
      :examinee-user-id="examineeUserId" @success="toJudge" />
  </div>
</template>

<script>
import ListHeader from './ListHeader'
import ScoreArea from './ScoreArea'
import AnswerArea from './AnswerArea'
import SearchExamineeDialog from './SearchExamineeDialog'
import { get, post } from '@/utils/ajax'
import Loading from '@/components/Loading'
import Modal from '@/components/Modal'

/**
 * 阅卷【考生模式】
 */
export default {
  components: {
    ListHeader,
    ScoreArea,
    AnswerArea,
    SearchExamineeDialog,
    Loading,
    Modal
  },
  data() {
    return {
      loading: false,
      examineeInfo: {}, // 考生信息
      questionList: [], // 题目列表
      currentQuestion: {}, // 当前题目
      currentAnswer: {}, // 当前题目答案
      showDoneModal: false // 全部评完弹窗
    }
  },
  computed: {
    // 阅卷ID
    markingId() {
      return this.$route.query.id
    },
    // 阅卷老师ID
    judgeId() {
      return this.$route.query.judgeId
    },
    // 考生账号ID
    examineeUserId() {
      return this.$route.query.examineeUserId
    },
    // 是否是第一题
    isFirst() {
      if (this.questionList.length === 0) {
        return true
      }
      return this.currentQuestion.questionId === this.questionList[0].questionId
    },
    // 是否是最后一题
    isLast() {
      if (this.questionList.length === 0) {
        return true
      }
      return this.currentQuestion.questionId === this.questionList[this.questionList.length - 1].questionId
    }
  },
  watch: {
    '$route': function () {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.$refs.searchExamineeDialogRef.hide()
      if (this.examineeUserId) {
        this.fetchQuestionList()
      } else {
        this.showSearchDialog()
      }
    },
    // 显示快速查找弹窗
    showSearchDialog(hasClose = false) {
      this.$refs.searchExamineeDialogRef.show(hasClose)
    },
    toJudge(data) {
      this.$router.push({
        query: {
          ...this.$route.query,
          examineeUserId: data.userId,
          recordId: undefined
        }
      })
    },
    // 根据考生账号ID获取阅卷题目信息列表
    async fetchQuestionList() {
      try {
        this.loading = true
        const { examineUserId, examineName, questions } = await post(`/home/markingAll/marking/${this.markingId}/judge/${this.judgeId}/user/${this.examineeUserId}/questions`, null, { ignoreMsg: true })
        this.loading = false
        if (questions.length === 0) {
          this.examineeInfo = {}
          this.questionList = []
          this.currentQuestion = {}
          this.$message.warning('该试卷还未分配阅卷任务')
          this.showSearchDialog()
          return
        }
        this.examineeInfo = { userId: examineUserId, userName: examineName }
        this.questionList = questions
        const recordId = this.$route.query.recordId

        // 从阅卷记录进入
        if (recordId) {
          this.fetchQuestionAnswer(recordId)
        } else {
          this.fetchQuestionAnswer(questions[0].markingBasketId) // 初始化第一个任务
        }
      } catch (e) {
        this.loading = false
        this.examineeInfo = {}
        this.questionList = []
        this.currentQuestion = {}
        if (e.error_code === 20626010) {
          this.$message.error('该考生已被其他老师阅卷')
        } else if (e.error_code === 20626011) {
          this.$message.error('该考生账号ID不存在')
        } else if (e.error_code === 20626012) {
          const user = e.error_msg.split(',')
          const data = {
            userId: user[1],
            userName: user[0]
          }
          this.$refs.searchExamineeDialogRef.showAlert(data)
          return
        } else {
          this.$message.error(e.error_msg || '网络请求异常')
        }
        this.showSearchDialog()
      }
    },
    // 拉取题目答案和评分信息
    async fetchQuestionAnswer(id) {
      try {
        this.loading = true
        this.currentAnswer = await get(`/home/judges/baskets/${id}`)
        this.currentQuestion = this.questionList.find(el => el.markingBasketId === +id)
        this.loading = false
      } catch (e) {
        this.currentAnswer = {}
        this.loading = false
      }
    },
    // 切换题号
    changeQuestion(action, markingBasketId) {
      let id = markingBasketId || this.currentQuestion.markingBasketId
      const currentIndex = this.questionList.findIndex(el => el.markingBasketId === id)
      if (action === 'prev') {
        id = this.questionList[currentIndex - 1] && this.questionList[currentIndex - 1].markingBasketId
      } else if (action === 'next') {
        id = this.questionList[currentIndex + 1] && this.questionList[currentIndex + 1].markingBasketId
      }
      if (id) {
        this.fetchQuestionAnswer(id)
      }
    },
    // 提交批改
    async submitScore(scores, mark, isEdit, noPointScore) {
      const params = {
        judge_id: this.judgeId,
        marking_basket_id: this.currentQuestion.markingBasketId,
        items: scores,
        note: mark,
        score: noPointScore
      }
      try {
        this.loading = true
        await post('/home/markingAll/judge/score', params)
        this.currentQuestion.markingStatus = 1
        this.$message.success('提交成功！')
        if (!isEdit) {
          this.isAllDone()
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    isAllDone() {
      const unjudgeds = this.questionList.filter(el => el.markingStatus === 0)
      if (unjudgeds.length === 0) {
        this.showDoneModal = true
        this.$refs.headerRef.fetchJudgeds()
      } else {
        // 如果不是最后一题/修改，就自动拉下一个任务
        this.changeQuestion('next')
      }
    },
    onAllDone() {
      this.showDoneModal = false
      this.showSearchDialog(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.examinee-mode-wrap {
  min-width: 1400px;
  height: 100%;
}

.list {
  width: 100%;
  height: 100%;
  position: relative;
}

.content {
  height: calc(100% - 64px);
}

.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.done-modal {
  font-size: 14px;
  color: #333;
  text-align: center;

  /deep/ .content {
    text-align: center;
  }

  .icon-done {
    display: inline-block;
    width: 54px;
    height: 55px;
    background: url('~@/assets/images/judge/icon-done.png') center / cover no-repeat;
    margin: 20px 0 5px 0;
  }

  .btn {
    @include theme-fill-btn(96px, 36px, 14px, 4px);
    margin-top: 32px;
    margin-bottom: 10px;
  }
}
</style>
